import { fork, put, all, takeLatest, select } from "redux-saga/effects";

import {
  toggleEnvironment,
  setEnvironment,
  selectEnvironment,
} from "../store/appSlice";

import { ENV_SANDBOX, ENV_PRODUCTION } from "../constants/environment";

import {
  startNotificationsPolling,
  stopNotificationsPolling,
} from "../store/notificationsSlice";

import { history } from "../store";

function* toggleEnvironmentSaga() {
  const currentEnvironment = yield select(selectEnvironment);
  const newEnvironment =
    currentEnvironment === ENV_PRODUCTION ? ENV_SANDBOX : ENV_PRODUCTION;
  yield put(setEnvironment(newEnvironment));
  yield autoRefetchEntities();

  // reset notifications
  yield put(stopNotificationsPolling());
  yield put(startNotificationsPolling());
}

// Resolve [MP-161].
// Kinda hackish but necessary due to unexpected rerender components on details/edit pages for apps, customers, accounts.
// To refactor in future.
function autoRefetchEntities() {
  const redirectRegex = /((\/configuration\/(customers|accounts))|(\/administration\/(banks))|(\/transactions))\//;

  const match = history.location.pathname.match(redirectRegex) || false;
  if (Array.isArray(match) && match.length > 0) {
    history.push({
      pathname: match[1],
    });
  }
}

function* watchToggleEnvironment() {
  yield takeLatest(toggleEnvironment().type, toggleEnvironmentSaga);
}

export default function* rootSaga() {
  yield all([fork(watchToggleEnvironment)]);
}
